import dayjs from 'dayjs';

export function getPurchaseOrderValidDeliveryDates(
  colorValidShipDates: {
    validShipDates: {
      from: Date | string | null;
      to: Date | string | null;
    };
  }[]
) {
  const availableDeliveryDates: {
    from: dayjs.Dayjs;
    to: dayjs.Dayjs | null;
  } = {
    from: dayjs(),
    to: null,
  };

  for (const color of colorValidShipDates) {
    const colorFromDate = color.validShipDates?.from ? dayjs(color.validShipDates.from) : null;

    const colorToDate = color.validShipDates?.to ? dayjs(color.validShipDates.to) : null;

    if (colorFromDate) {
      if (!availableDeliveryDates.from || colorFromDate.isAfter(availableDeliveryDates.from)) {
        availableDeliveryDates.from = colorFromDate;
      }
    }

    if (colorToDate) {
      if (!availableDeliveryDates.to || colorToDate.isBefore(availableDeliveryDates.to)) {
        availableDeliveryDates.to = colorToDate;
      }
    }
  }

  return {
    from: availableDeliveryDates.from.toDate(),
    to: availableDeliveryDates.to ? availableDeliveryDates.to.toDate() : null,
  };
}
